// Notifications — the full-page feed. Phones reach it from the tab bar; on
// desktop the topbar bell opens the same feed (components/NotificationFeed)
// in a side drawer instead.

import type { ReactElement } from 'react';
import { useNotifCounts } from '../components/AppShell';
import {
  NotificationFilter,
  NotificationList,
  useNotificationFeed,
} from '../components/NotificationFeed';

export default function NotificationsPage(): ReactElement {
  const { counts, refresh } = useNotifCounts();
  const feed = useNotificationFeed(counts, refresh);

  return (
    <>
      <div className="page-head">
        <div className="titles">
          <h1>{feed.title}</h1>
          <div className="subtitle">{feed.subtitle}</div>
        </div>
        <NotificationFilter feed={feed} />
      </div>

      <NotificationList feed={feed} />
    </>
  );
}
